'use strict';

var processInclude = require('./util');
require('./thirdParty/slick-carousel');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/wishlist'));
    processInclude(require('./product/quickView'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/productTileSlider'));
    processInclude(require('./product/storesStock'));
    processInclude(require('custom_adyen/adyen/express/product/expressPayments'));
});
